<template>
  <div class="koc-block koc-event-price-box-block">
    <div class="koc-event-price-box-container">
      <div class="koc-event-price-box-header">
        <div
          v-if="state.showRibbonBar(userEvents)"
          :class="state.ribbonBarColorClass(userEvents)"
          class="koc-ribbon koc-ribbon-top-right"
        >
          <span>{{ state.ribbonText(userEvents) }}</span>
        </div>
        <div class="koc-title-1 koc-title-event-price-box-header-text">
          {{ state.titleText(event) }}
        </div>
        <div class="koc-title-1 koc-event-price-box-header-price">
          <div
            v-if="state.resaleEligible(userEvents)"
            class="koc-event-price-box-header-price-row"
          >
            <div class="koc-event-price-box-price-block fullprice">
              <span class="koc-title-4 koc-event-price-box-dollarsign"><span
                class="koc-line-through"
              >$</span></span><span
                class="koc-line-through"
              >{{ inPersonOnly ? event.in_person_product_price : event.price }}</span>
            </div>
            <div class="koc-event-price-box-price-block">
              <span
                class="koc-title-4 koc-event-price-box-dollarsign"
              >$</span>{{ event.resale.price }}
            </div>
          </div>
          <div
            v-else-if="state.onSale"
            class="koc-event-price-box-header-price-row"
          >
            <div class="koc-event-price-box-price-block fullprice">
              <span class="koc-title-4 koc-event-price-box-dollarsign"><span
                class="koc-line-through"
              >$</span></span><span
                class="koc-line-through"
              >{{ inPersonOnly ? event.in_person_product_price : event.price }}</span>
            </div>
            <div class="koc-event-price-box-price-block">
              <span
                class="koc-title-4 koc-event-price-box-dollarsign"
              >$</span>{{ event.sale.price }}
            </div>
          </div>
          <div
            v-else
            class="koc-event-price-box-header-price-row"
          >
            <div class="koc-event-price-box-price-block">
              <span
                class="koc-title-4 koc-event-price-box-dollarsign"
              >$</span>{{ inPersonOnly ? event.in_person_product_price : event.price }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="state.showRibbonBar(userEvents)"
        :class="state.ribbonBarColorClass(userEvents)"
        class="koc-event-card-color-bar"
      />
      <div class="koc-event-price-box-subhead">
        <h1 class="koc-title-3">
          {{ state.subheaderText(userEvents, user) }}
        </h1>
      </div>
      <div
        v-if="!showCheckout"
        class="koc-event-price-box-body"
      >
        <button
          :disabled="state.buttonDisabled(userEvents)"
          class="koc-title-3 koc-button koc-ripple"
          @click="buttonClick(state.buttonUrl(userEvents))"
        >
          {{ state.buttonText(userEvents) }}
        </button>
        <span
          v-if="!user"
          class="koc-event-price-box-body-login"
        >or already purchased <a
          class="koc-secondary-text"
          href="javascript:void(0);"
          @click="login"
        >Log in here</a>
        </span>
        <span
          v-if="state.detailsUrl"
          class="koc-event-price-box-live-event-info"
        ><a
          class="koc-secondary-text"
          target="_blank"
          :href="state.detailsUrl"
        >view in-person event info</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script src="./event-price-box.js"></script>
<style lang="scss" scoped src="./event-price-box.scss"></style>
